import type { LicenseTerms } from "~/types/api";
import { BaseAPI } from "./base";
import type { ApiResponse } from "~/types/ui";

export class LicenseApi extends BaseAPI {
  async getTerms(): Promise<ApiResponse<LicenseTerms>> {
    return this.get<LicenseTerms>(`license/terms`);
  }
}
